import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/collections-women";

export default class CollectionsWomen extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `${this.ucfirst("Women's Collections")} | ${this.ucfirst("window-title")}`
    );
  }
}
